export const PER_BATCH_PATHS = {
  '/evidence': '/batches/:id/evidence',
  '/exceptions': '/batches/:id/exceptions',
  '/approvals': '/batches/:id/approvals',
  '/mass-balance': '/batches/:id/mass-balance',
  '/audit-package': '/batches/:id/audit-package',
  '/operations/inbound': '/batches/:id/inbound',
  '/operations/sorting': '/batches/:id/sorting',
  '/operations/dismantling': '/batches/:id/dismantling',
  '/operations/secondary-process': '/batches/:id/outbounds',
  '/operations/inventory': '/batches/:id/inventory',
  '/operations/shipments': '/batches/:id/outbounds',
  '/operations/weight-difference': '/batches/:id/weight-difference',
  '/operations/disassembly-batches': '/batches/:id/dismantling',
  '/operations/sales-outbounds': '/batches/:id/outbounds',
  '/operations/outbounds': '/batches/:id/outbounds',
  '/valuation/first': '/batches/:id/first-valuation',
  '/valuation/monthly-material': '/batches/:id/valuation/monthly-material',
  '/valuation/supplier-purchase-price': '/batches/:id/valuation/supplier-purchase-price',
  '/valuation/getit-purchase-price': '/batches/:id/valuation/supplier-purchase-price',
  '/settlement': '/batches/:id/settlement',
  '/reports/monthly': '/batches/:id/reports',
  '/valuation/supplier-quotation': '/batches/:id/supplier-quotation',
  '/operations/buyer-proposals': '/batches/:id/buyer-proposals',
} as const;

export type PerBatchPath = keyof typeof PER_BATCH_PATHS;

export const getPerBatchTemplate = (path: string): string | undefined =>
  PER_BATCH_PATHS[path as PerBatchPath];

export const resolvePerBatchPath = (path: string, batchId: string | null | undefined): string => {
  const template = getPerBatchTemplate(path);
  return template && batchId ? template.replace(':id', batchId) : path;
};
